import React from 'react';
import buttonTypes from './index';

const Button = ( props ) => {
   return <>{ buttonTypes( props ) }</>;
};

export default Button;
